import moment from 'moment'

const formatDate = function (value) {
    if (value) {
        return moment(value).format("YYYY/MM/DD HH:mm");
    }
    return "";
};

const movieModes = {
    2: '2D',
    3: '3D',
    4: 'SBS',
    5: 'T&B',
};

const formatMode = (mode) => {
    return movieModes[mode] || '';
};

const hhMMss = function (value) {
    if (value !== null && value !== undefined && value >= 0) {
        const hour = Math.floor(value / 60 / 60);
        const minute = Math.floor(value / 60) % 60;
        const second = value % 60;
        return `${hour}時間${minute}分${second}秒`
    }
    return "";
};

export { formatDate, formatMode, hhMMss };



// WEBPACK FOOTER //
// ./src/components/filters/format.js